<template>
  <div class="flex flex-col gap-2 -mt-10 mb-8">
    <div class="flex items-center justify-between mb-4">
      <h4 class="mb-2">Quiz</h4>
      <Button
        :label="$t('labels.generic', { pt: 'Baixar', en: 'Download' })"
        icon="pi pi-download"
        class="p-button-sm btn-primary h-9"
        :loading="btnLoading"
        @click="downloadCSV"
      />
    </div>
    <div class="bg-white rounded-lg border border-gray-300">
      <Table
        :slotData="performance"
        :columns="columns"
        :loading="loader"
        :params="params"
        :filters="filters"
        :hasStatus="false"
        :hasActions="false"
        :actionsTitle="''"
        :actions="actions"
        @onPaginate="paginate($event)"
      >
      </Table>
    </div>
  </div>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { QuizIndividualStudent } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { quizStatsStudent } from "@/views/Stats/Student/Quiz/quiz.utils";
import saveAs from "file-saver";
import { delay } from "rxjs";
import { defineComponent } from "vue";
import { QuizService } from "./quiz.service";

export default defineComponent({
  name: "quiz",
  props: {
    courseId: {
      type: String,
      default: "",
    },
    studentId: {
      type: String,
      default: "",
    },
  },
  computed: {
    quizService(): QuizService {
      return new QuizService();
    },
    rest(): StatsRest {
      return new StatsRest();
    },
    classroomId(): string {
      return String(localStorage.getItem("stdClassroomId"));
    },
  },
  mounted() {
    this.quizPaginated();
  },
  data() {
    return {
      columns: quizStatsStudent,
      actions: [],
      params: new QueryParams(),
      filters: {
        isCleareable: false,
        name: null,
      } as any,
      performance: [] as QuizIndividualStudent[],
      loader: true as boolean,
      btnLoading: false as boolean,
    };
  },
  methods: {
    paginate(event: { page: number; rows: number }): void {
      const params = new QueryParams(event.page, event.rows);
      params.name = this.filters.name;
      this.getQuizStudentFromCourse(params);
    },
    quizPaginated(): void {
      const page = this.params.page;
      const size = this.params.size;
      const params = new QueryParams(page, size);
      this.getQuizStudentFromCourse(params);
    },
    getQuizStudentFromCourse(queryParams: QueryParams): void {
      this.quizService.quiz.subscribe({
        next: (response: any) => {
          this.loader = false;
          this.performance = response.content;
          this.params.total = response.total;
        },
      });
      this.quizService.getQuizStudentFromCourse(
        this.courseId,
        this.studentId,
        queryParams
      );
    },
    downloadCSV(): void {
      this.btnLoading = true;
      this.rest
        .getStudentsQuizStatsCsv(this.courseId, this.studentId, {
          classroomId: this.classroomId ?? undefined,
        })
        .pipe(delay(1000))
        .subscribe({
          next: (response) => {
            this.btnLoading = false;
            const blob = new Blob([response], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            saveAs(url, `students_quiz_data.csv`);
          },
          error: () => {
            this.btnLoading = false;
          },
        });
    },
  },
});
</script>
